import React from 'react';
import PropTypes from 'prop-types';

import './Form.scss';

const FormErrorInline = (
  {
    children,
    ...props
  }
) => <div className="Form__Error_Inline" role="alert" aria-live="polite" {...props}>{children}</div>;

FormErrorInline.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormErrorInline;
